// ============================================
// components/friends/FriendRequests.js
// ============================================
import React, { useState } from 'react';
import { Box, Paper, Typography, List, ListItem, Button, CircularProgress } from '@mui/material';

const FriendRequests = ({ requests, currentUserId, onAccept, onDeny, isLightOn = false }) => {
  const [loadingId, setLoadingId] = useState(null);
  
  const pendingRequests = requests.filter(
    req => req.recipientUid === currentUserId && req.status === 'pending'
  );

  if (pendingRequests.length === 0) return null;

  const handleAction = async (action, requestId) => {
    setLoadingId(requestId);
    await action(requestId);
    setLoadingId(null);
  };

  return (
    <Paper elevation={0} variant="glass" data-testid="friend-requests-section" sx={{
      mt: 2,
      width: '100%',
      maxWidth: 400,
      p: 3,
      mx: 2
    }}>
      <Typography
        variant="h6"
        component="h2"
        sx={{ color: isLightOn ? 'primary.contrastText' : 'text.primary', fontWeight: 700, mb: 2, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}
      >
        Friend Requests
      </Typography>
      <List sx={{ overflowX: 'visible', pl: 0.5 }}>
        {pendingRequests.map((request) => (
          <ListItem 
            key={request.id} 
            sx={{ px: 0, py: 1, display: 'flex', alignItems: 'center', overflow: 'visible' }}
            data-testid="friend-request"
          >
            <img
              src="/on_badge.png"
              alt="Request badge"
              className="badge-animated"
              style={{ width: 34, height: 34, marginRight: 16, verticalAlign: 'middle', borderRadius: 6 }}
            />
            <Typography
              variant="body1"
              sx={{ color: isLightOn ? 'primary.contrastText' : 'text.primary', fontSize: { xs: '1rem', sm: '1.08rem' }, fontWeight: 400, flex: 1 }}
            >
              {request.requesterFirstName || 'Someone'} wants to be your friend
            </Typography>
            <Button
              variant="text"
              size="small"
              onClick={() => handleAction(onDeny, request.id)}
              disabled={loadingId === request.id}
              className="button-animated"
              sx={{ ml: 1, minWidth: 60, color: isLightOn ? 'primary.contrastText' : 'text.primary' }}
              data-testid="deny-request-btn"
            >
              {loadingId === request.id ? <CircularProgress size={18} color="inherit" /> : 'Deny'}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleAction(onAccept, request.id)}
              disabled={loadingId === request.id}
              className="button-animated"
              sx={{ ml: 2, minWidth: 80 }}
              data-testid="accept-request-btn"
            >
              {loadingId === request.id ? <CircularProgress size={18} color="inherit" /> : 'Accept'}
            </Button>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default FriendRequests;
